import { render, staticRenderFns } from "./app-detail-rank-list.vue?vue&type=template&id=a74023b4&scoped=true&"
import script from "./app-detail-rank-list.vue?vue&type=script&lang=js&"
export * from "./app-detail-rank-list.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-rank-list.vue?vue&type=style&index=0&id=a74023b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74023b4",
  null
  
)

export default component.exports